import { Component, Input } from '@angular/core';

@Component({
  selector: 'doc-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  standalone: false,
})
export class PageTitleComponent {
  
    @Input() breadcrumbItems;
    @Input() title: string;
  
    constructor() { }
  
  }
  
